const Apikeys = {
  form: (token: string, customer_id: number, filters?: any) =>
    ["form", token, customer_id, filters] as const,
};

export default Apikeys;
